<div class="input-wrapper">
  <mat-checkbox [checked]="textIsEditable" (change)="textIsEditable = !textIsEditable"> Text editable </mat-checkbox>
</div>

<div [formGroup]="form" class="input-wrapper">
  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('moneyAmount').value"
    textAlign="left"
    unit="€"
    unitPosition="right"
    [autofillDecimals]="true"
  >
    <mat-form-field class="form-group">
      <mat-label>Money Amount</mat-label>
      <input
        formControlName="moneyAmount"
        autocomplete="off"
        class="form-control"
        id="moneyAmount"
        matInput
        unit="€"
        [autofillDecimals]="true"
        textAlign="right"
        madNumericField
      />
      @if (!form.get('moneyAmount').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('weight').value"
    textAlign="right"
    unit="kg"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Weight</mat-label>
      <input formControlName="weight" autocomplete="off" class="form-control" id="weight" matInput unit="kg" madNumericField />
      @if (!form.get('weight').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('emission').value"
    textAlign="right"
    unit="g/km"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Emission</mat-label>
      <input formControlName="emission" autocomplete="off" class="form-control" id="emission" matInput unit="g/km" madNumericField />
      @if (!form.get('emission').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('kilometer').value"
    textAlign="right"
    unit="km"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Kilometer Reading</mat-label>
      <input formControlName="kilometer" autocomplete="off" class="form-control" id="kilometer" matInput unit="km" madNumericField />
      @if (!form.get('kilometer').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('cubicCapacity').value"
    textAlign="right"
    unit="cc"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Cubic Capacity</mat-label>
      <input
        formControlName="cubicCapacity"
        autocomplete="off"
        class="form-control"
        id="cubicCapacity"
        matInput
        unit="cc"
        madNumericField
      />
      @if (!form.get('cubicCapacity').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('millimeter').value"
    textAlign="right"
    unit="mm"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Millimeter</mat-label>
      <input formControlName="millimeter" autocomplete="off" class="form-control" id="millimeter" matInput unit="mm" madNumericField />
      @if (!form.get('millimeter').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('kilowatt').value"
    textAlign="right"
    unit="kW"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Kilowatt</mat-label>
      <input formControlName="kilowatt" autocomplete="off" class="form-control" id="kilowatt" matInput unit="kW" madNumericField />
      @if (!form.get('kilowatt').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('timeunit').value"
    textAlign="right"
    unit="TU"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Timeunit</mat-label>
      <input formControlName="timeunit" autocomplete="off" class="form-control" id="timeunit" matInput unit="TU" madNumericField />
      @if (!form.get('timeunit').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('horsepower').value"
    textAlign="right"
    unit="hp"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Horsepower</mat-label>
      <input formControlName="horsepower" autocomplete="off" class="form-control" id="horsepower" matInput unit="hp" madNumericField />
      @if (!form.get('horsepower').valid) {
        <mat-error> Please enter a value greater than or equal to 0 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>

  <mad-readonly-form-field-wrapper
    [readonly]="!textIsEditable"
    [value]="form.get('percentage').value"
    textAlign="right"
    unit="%"
    unitPosition="right"
  >
    <mat-form-field class="form-group">
      <mat-label>Percentage</mat-label>
      <input formControlName="percentage" autocomplete="off" class="form-control" id="percentage" matInput unit="%" madNumericField />
      @if (!form.get('percentage').valid) {
        <mat-error> Please enter a value between 0 and 100 </mat-error>
      }
    </mat-form-field>
  </mad-readonly-form-field-wrapper>
</div>
